import type { Interceptor } from '@connectrpc/connect';

export function MFAInterceptor(): Interceptor {
  const headerName = 'mfa-token'.toLowerCase();

  return (next) => async (req) => {
    if (req.method.name !== 'VerifyTOTP') {
      return await next(req);
    }

    const token = localStorage.getItem('temporary_token');
    if (!token) {
      return await next(req);
    }

    const headers = new Headers(req.header);
    headers.set(headerName, token);

    return await next({ ...req, header: headers });
  };
}
